import React, {
  useState,
  useEffect,
} from "react";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

import { useLocation } from "react-router-dom";

import school1 from "../assets/stschool.jpg";
import principalImg from "../assets/archive/principal.jpg";

const About = () => {
  const location = useLocation();

  const [open, setOpen] =
    useState(false);

  useEffect(() => {
    if (location.hash) {
      const el =
        document.querySelector(
          location.hash
        );

      if (el) {
        setTimeout(() => {
          el.scrollIntoView({
            behavior:
              "smooth",
          });
        }, 100);
      }
    }
  }, [location]);

  return (
    <>
      <Header
        toggleSidebar={() =>
          setOpen(true)
        }
      />

      <Sidebar
        isOpen={open}
        close={() =>
          setOpen(false)
        }
      />

      {/* HERO SECTION */}
      <section
        style={{
          background:
            "#0b3471",
          padding:
            "90px 20px",
          textAlign:
            "center",
        }}
      >
        <h1
          style={{
            color: "#fff",
            fontSize:
              "clamp(42px,7vw,85px)",
            fontWeight:
              "700",
            letterSpacing:
              "2px",
            marginBottom:
              "15px",
          }}
        >
          ABOUT US
        </h1>

        <p
          style={{
            color:
              "#ffffff",
            fontSize:
              "clamp(18px,2vw,28px)",
            fontWeight:
              "500",
          }}
        >
          Excellence In
          Education &
          Character Building
        </p>

        <div
          style={{
            width: "120px",
            height: "5px",
            background:
              "#d4a017",
            margin:
              "28px auto 0",
            borderRadius:
              "20px",
          }}
        />
      </section>

      {/* ABOUT CONTENT */}
      <section
        style={{
          background:
            "#f5f7fb",
          padding:
            "70px 20px",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            margin: "0 auto",
          }}
        >
          {/* MAIN CARD */}
          <div
            style={{
              background:
                "#ffffff",
              borderRadius:
                "30px",
              overflow:
                "hidden",
              boxShadow:
                "0 10px 35px rgba(0,0,0,0.08)",
            }}
          >
            {/* IMAGE */}
            <div
              style={{
                width: "100%",
                overflow:
                  "hidden",
              }}
            >
              <img
                src={school1}
                alt="School"
                style={{
                  width: "100%",
                  height: "100%",
                  maxHeight:
                    "620px",
                  objectFit:
                    "cover",
                  display:
                    "block",
                }}
              />
            </div>

            {/* CONTENT */}
            <div
              style={{
                padding:
                  "50px 35px",
              }}
            >

              <p
                style={{
                  color:
                    "#555",
                  fontSize:
                    "18px",
                  lineHeight:
                    "2",
                  marginBottom:
                    "25px",
                  textAlign:
                    "justify",
                }}
              >
                St. Joseph’s
                School was
                founded in
                1993. It is
                located at
                Maharajganj,
                Uttar Pradesh.
                It has about 2
                acre 12 decimal
                of land. It is
                run by Miss
                Jancy Memorial
                Welfare Society
                (A Christian
                minority
                society).
              </p>

              <p
                style={{
                  color:
                    "#555",
                  fontSize:
                    "18px",
                  lineHeight:
                    "2",
                  marginBottom:
                    "25px",
                  textAlign:
                    "justify",
                }}
              >
                The strength
                of the school
                is increasing
                day by day.
                The school has
                grown very
                rapidly and
                has earned the
                name of being
                one of the
                most
                prestigious
                schools at
                Maharajganj,
                U.P. The
                school is
                committed to
                personalized
                teaching.
              </p>

              <p
                style={{
                  color:
                    "#555",
                  fontSize:
                    "18px",
                  lineHeight:
                    "2",
                  marginBottom:
                    "25px",
                  textAlign:
                    "justify",
                }}
              >
                The School
                aims to give
                the students a
                balanced
                variety of
                educational,
                social and
                cultural
                experiences to
                prepare them
                for life
                itself.
                Children are
                admitted as
                day scholars.
                The school has
                classes from 1
                to X.
              </p>

              {/* AFFILIATION BOX */}
              <div
                style={{
                  background: "#0b3471",
                  borderRadius: "18px",
                  padding: "28px 30px",
                  margin: "35px 0",
                }}
              >
                <h3
                  style={{
                    color: "#ffffff",
                    fontSize: "20px",
                    fontWeight: "700",
                    lineHeight: "1.5",
                    marginBottom: "14px",
                  }}
                >
                  Affiliated To Central Board Of
                  Secondary Education (C.B.S.E.)
                  New Delhi
                </h3>

                <div
                  style={{
                    width: "70px",
                    height: "4px",
                    background: "#d4a017",
                    borderRadius: "20px",
                  }}
                />
              </div>

              <p
                style={{
                  color:
                    "#555",
                  fontSize:
                    "18px",
                  lineHeight:
                    "2",
                  textAlign:
                    "justify",
                }}
              >
                The qualified
                and experienced
                staff believes
                in challenging
                their own
                abilities as
                well as the
                abilities of
                their
                students.
                They are always
                in search of
                new ideas
                adaptable to
                the demands of
                changing
                times. The
                medium of
                instruction is
                English and
                the Second
                language
                taught is
                Hindi. The
                Third Language
                offered is
                Sanskrit. The
                School is
                secular in
                character.
              </p>
            </div>
          </div>

          {/* PRINCIPAL DESK */}
          <section
            id="principle"
            className="w-full bg-[#F5F6FA] py-16 md:py-20"
          >

            <div className="max-w-6xl mx-auto px-4 md:px-8">

              {/* MAIN BOX */}
              <div className="bg-[#F6F3E7] border border-[#DDD6BE] shadow-sm">

                {/* TOP BAR */}
                <div className="h-4 bg-[#072F5F]" />

                <div className="p-6 md:p-10">

                  {/* TITLE */}
                  <div className="text-center mb-10">
                    <h2 className="text-[#072F5F] text-3xl md:text-5xl font-bold uppercase">
                      Principal Desk
                    </h2>

                    <div className="w-16 h-1 bg-[#F59E0B] mx-auto mt-3" />
                  </div>

                  {/* CONTENT */}
                  <div className="text-gray-800 text-base md:text-lg leading-8 text-justify">

                    {/* IMAGE */}
                    <div className="float-left w-full md:w-[260px] mr-0 md:mr-8 mb-4">

                      <img
                        src={principalImg}
                        alt="Principal"
                        className="w-full h-[300px] object-cover border border-gray-300"
                      />

                      {/* NAME */}
                      <div className="mt-3 text-center">
                        <h3 className="text-red-600 text-2xl font-bold uppercase">
                          Principal
                        </h3>

                        <p className="text-[#072F5F] text-lg font-semibold">
                          Lily Thomas
                        </p>
                      </div>
                    </div>

                    {/* TEXT */}
                    <p>
                      The school is a place where children are encouraged to say.
                      <span className="font-semibold text-[#072F5F]">
                        {" "}“I see it, I get it, I can do it.”
                      </span>
                    </p>

                    <p className="mt-5">
                      We are one of the largest educational institutions in the north eastern part of the state U.P.
                      with a mission,” From Darkness to Light “in all spheres. Set up in 2005
                      St. Joseph’s school has journeyed the through all these years and gained the trust and
                      appreciation of hundreds of students and their parents alike.
                    </p>

                    <p className="mt-5">
                      Our philosophy of education has always been meeting the needs of the individual child.
                      Children acquire skills and knowledge easily if we can make the surrounding stimulating
                      and purposeful. In the 21st century the Digital revolution affects us all.
                      Quite simply it is changing everything a brilliant barrage of information is speedily available .
                      In such a surrounding when work and effort is valued, the child’s self esteem is heightened.
                      We try to understand and work on each child, and
                      we firmly believe that it is our responsibility to enable the child in care to develop as a whole.
                    </p>

                    <p className="mt-5">
                      We all are concerned children as they have lives beyond the class room,
                      and we cannot meet their needs if we show no concern for their activities outside the school.
                      We are the first institute in the surroundings to have started, CBSE syllabus school.
                    </p>

                    <p className="mt-5">
                      We put forward a distinctive bland of offerings in the areas of knowledge and
                      enterprise in the form of encouraging students for quiz contest, competitive exams as well as
                      organizing and taking part in various cultural events. We have an optional extracurricular a
                      ctivity program every Saturday,
                      where multi furious disciplines like music, dance, sports and games etc. are being taught.
                    </p>

                    <p className="mt-5">
                      I do appreciate and offer thanks – giving to all the teaching staff and
                      the students who are part of this School. We pledge to work for every child
                      and in the area of education.
                    </p>

                    <div className="clear-both" />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

      </section>

      <Footer />
    </>
  );
};

export default About;